const routes = [
    {
        path: 'chamados',
        name: 'listarAtendimentos',
        alias: 'chamados/index',
        component: () => import('../views/Listar.vue')
    },

    {
        path: 'chamados/index/:id',
        name: 'listarAtendimentosId',
        redirect: to => ({
            path: 'atendimentos',
            query: { id: to.params.id }
        })
    },
    {
        path: 'chamados/adicionar',
        component: () => import('../views/Adicionar.vue')
    },
    {
        path: 'chamados/editar/:id',
        component: () => import('../views/Editar.vue')
    },
    {
        path: 'chamados/visualizar/:id',
        component: () => import('../views/Visualizar.vue')
    },


]

export default routes
